import React from "react";
import { ResponsiveType } from "../../../interface/redux/config";
import { useLanguage } from "../../../hooks/useLanguage";
import styles from "./Ci.module.css";

type Props = { Responsive: ResponsiveType };

const CiSection1 = (_: Props) => {
  const { isKr } = useLanguage();
  return (
    <section className={styles.section}>
      <p className={styles.eyebrow}>HUCONN IDENTITY</p>
      <h1 className={styles.title}>{isKr ? "기술로 인류를 포용합니다" : "Embracing humanity with technology"}</h1>
      <p className={styles.copy}>
        {isKr
          ? "휴컨의 로고는 여섯 개의 모듈로 이루어진 심볼과 HUCONN 워드마크를 하나로 담았습니다. 서로 다른 요소가 연결되어 하나의 형태를 이루듯, 다양한 기술과 경험을 모아 사람을 위한 가치를 만들어가는 휴컨을 표현합니다."
          : "The HUCONN logo brings together a six-module symbol and the HUCONN wordmark. Its distinct elements form a connected whole, expressing how we bring technology and experience together to create value for people."}
      </p>
      <div className={styles.hero}>
        <img src="/assets/brand/huconn-primary.svg" width={1740} height={362} alt={isKr ? "휴컨 기본 로고" : "HUCONN primary logo"} />
      </div>
    </section>
  );
};
export default CiSection1;
